import useSWR, {SWRConfiguration} from 'swr';
import letrusAPI from '../axiosInstance';
import {LearningPathStep} from './types';

export function fetchLearningPathStepRequest(
  lpuiId: string,
  SWRConfig?: SWRConfiguration<LearningPathStep>,
) {
  return useSWR<LearningPathStep>(
    [`/api/v1/new_learning_path_user_instances/`, lpuiId],
    ([url, lpuiId]) =>
      letrusAPI(`${url}${lpuiId}/details/`)
        .then((res) => res.data)
        .catch((error) => {
          throw new Error(error);
        }),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      ...SWRConfig,
    },
  );
}
